import { createSlice } from "@reduxjs/toolkit";
import { resolveOrganization } from "./thunk";
import { Organization } from "../types/organization.types";

interface OrganizationState {
  currentOrganization: Organization | null;
  resolvedSlug: string | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: OrganizationState = {
  currentOrganization: null,
  resolvedSlug: null,
  status: "idle",
  error: null,
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(resolveOrganization.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(resolveOrganization.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.currentOrganization = action.payload;
        state.resolvedSlug = action.meta.arg;
      })
      .addCase(resolveOrganization.rejected, (state, action) => {
        state.status = "failed";
        state.currentOrganization = null;
        // Keep resolvedSlug so we don't re-dispatch for the same slug (avoids infinite load)
        state.resolvedSlug = action.meta.arg;
        state.error =
          action.payload ??
          action.error.message ??
          "Failed to resolve organization";
      });
  },
});

export default organizationSlice.reducer;
